import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initMetaPixel } from "./utils/metaPixel";
function addLink(rel: string, href: string, extra: Record<string, unknown> = {}): HTMLLinkElement {
  const link = document.createElement("link");
  link.rel = rel;
  link.href = href;
  Object.assign(link, extra);
  document.head.appendChild(link);
  return link;
}

// Only preconnect to origins the platform doesn't already warm up itself.
// fonts.googleapis.com / fonts.gstatic.com are preconnected by the platform's
// own bootstrap — adding them again here just doubles up unused connections
// (flagged by Lighthouse). cdn.magicpatterns.com is the one origin that
// actually benefits: it serves the hero image, our LCP element.
addLink("preconnect", "https://cdn.magicpatterns.com");

// The hero image is the LCP element, but in a client-rendered SPA the browser's
// preload scanner can't see it until React renders the <img> tag. Preloading it
// here — before React even mounts — makes it discoverable from the very first
// network pass instead of waiting on JS execution.
addLink("preload", "https://cdn.magicpatterns.com/uploads/mfmCvTRZV6k4Vcdxb6hPSY/ChatGPT_Image_20_ago_2026__12_50_49__1_-removebg-preview.png", {
  as: "image",
  fetchPriority: "high"
});

// Load Google Fonts without blocking the initial render: fetch the stylesheet
// as a low-priority preload, then flip it to an active stylesheet once ready.
// Keeping this out of index.css's @import avoids nesting the font request
// inside the main stylesheet's critical request chain.
const fontsHref = "https://fonts.googleapis.com/css2?family=Oswald:wght@600;700&family=Inter:wght@400;500;600;700&display=swap";
const fontPreload = addLink("preload", fontsHref, {
  as: "style"
});
fontPreload.onload = () => {
  fontPreload.onload = null;
  fontPreload.rel = "stylesheet";
};

// The Meta Pixel ships ~220KB of third-party JS that isn't needed for the
// first paint and was showing up as unused/blocking work on load. Defer it
// until the browser is idle or the visitor actually starts interacting, so
// it never competes with the initial render or the hero image for bandwidth.
let pixelLoaded = false;
function loadMetaPixel() {
  if (pixelLoaded) return;
  pixelLoaded = true;
  initMetaPixel();
  interactionEvents.forEach(event => window.removeEventListener(event, loadMetaPixel));
}
const interactionEvents: Array<keyof WindowEventMap> = ["scroll", "keydown", "touchstart", "mousemove"];
interactionEvents.forEach(event => window.addEventListener(event, loadMetaPixel, {
  passive: true,
  once: true
}));
if ("requestIdleCallback" in window) {
  (window as unknown as {
    requestIdleCallback: (cb: () => void, opts?: {
      timeout: number;
    }) => void;
  }).requestIdleCallback(loadMetaPixel, {
    timeout: 4000
  });
} else {
  window.setTimeout(loadMetaPixel, 2500);
}
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-319" data-mp="2wkmsuf55hg1s" />);
}